import { render } from "./CloseButton.vue?vue&type=template&id=494c1486&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=ts"
export * from "./CloseButton.vue?vue&type=script&lang=ts"

import "./CloseButton.vue?vue&type=style&index=0&id=494c1486&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-494c1486"

export default script